export default __webpack_public_path__ + "static/media/video-rewind.a45d6a09.svg";